export default __webpack_public_path__ + "party-popper.307d16a1.png";